import React, { useContext, useEffect, useRef, useState, useCallback } from 'react';
import "../../../ui-styles/list/CardsList.css";
import "../../../ui-styles/search/Search.css";
import { LangCtx, SignalerCtx , FileCtx } from "../../../lib/context";
import AppointmentItem from './AppointmentListItem';
import { appointmentList } from "../../../actions/appointment";
import Loader from "../../../lib/ui/loader/Loader";
import { dateFormat } from "../../../lib/functions";
import NoData from "../../../lib/ui/nodata/NoData";
import UploadFileView from '../../common/fileUploads/components/uploadFileView';
import useDebounce from '../../common/useDebounce';
import VisitDetailsSlide from './visitDetialsSlide';
import PatientUploadsSlide from '../../common/appointments/components/PatientUploadsSlide';
import { API } from 'aws-amplify';

const DoctorAppointmentsList = (props) => {
    const { l } = useContext(LangCtx);
    const aptmntList = useRef(null);
    const { signaler } = useContext(SignalerCtx);
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selFile, setFileView] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const debouncedSearchTerm = useDebounce(searchTerm, 500);

    const [slideData, setSlideData] = useState(null);
    const [slideUploadData, setSlideUploadData] = useState(null);

    const searchRef = useRef('');

    useEffect(() => {
        if (signaler) {
            signaler.on(`reload-pending-list`, (message) => {
                props.type === "PEA" && loadData(props.type);
            });
            return () => {
                signaler.off(`reload-pending-list`, () => { });
            };
        }
    }, []);

    useEffect(() => {
        setSearchTerm('')
        loadData(props.type);
    }, [props.type]);

    useEffect(() => {
        if (searchRef.current !== searchTerm) {
            searchRef.current = searchTerm;
            loadData()
        }
    }, [debouncedSearchTerm]);


    // const handleSerach = (e) => {
    //     setSearchTerm(e.target.value)
    //     let val = e.target.value.trim();
    //     // if (val.length > 1 || val.length === 0) {
    //         let filter = val.toUpperCase();
    //         let li = aptmntList.current.getElementsByClassName('cardItem');
    //       //  let li = parent.getElementsByClassName('listAutoContent');
    //         let searchfound = false;
    //         for (let i = 0; i < li.length; i++) {
    //             let a = li[i].getElementsByClassName("cardTxtLg")[0];
    //             if (a) {
    //                 let txtValue = a.textContent || a.innerText;
    //                 if (txtValue.toUpperCase().indexOf(filter) > -1) {
    //                     li[i].style.display = "";
    //                     searchfound = true;
    //                 } else {
    //                     li[i].style.display = "none";
    //                 }
    //             }
    //         }
    //     // }
    // }

    const handleSlideData = (data) =>{
        setSlideUploadData(null);
        setSlideData(data);
    }

    const handleUploads = (data) => {
        setSlideData(null);
        setSlideUploadData(data)
    }

    const handleClose = () =>{
        setSlideData(null);
        
    }

    const handleUploadsClose = () =>{
        setSlideUploadData(null);
    }


    const loadData = useCallback(() => {
        setLoading(true);
        const { type } = props;
        let _f = new Date();
        let _t = new Date();
        let status = null;
        if (type === "PA") {
            _f.setDate(_f.getDate() - 30);
            status = ["pending", "confirmed"];
        } else if (type === "CA") {
            _f.setDate(_f.getDate() - 30);
            _t.setDate(_t.getDate() + 30);
            status = ["cancelled", "rejected"];
        } else {
            _t.setDate(_t.getDate() + 30);
            if (type === "PEA") {
                status = ["pending"];
            } else {
                _f.setDate(_f.getDate() + 1);
                _f.setHours(0,0,0,0);
                status = ["confirmed"];
            }
        }

        appointmentList("doctor", status, _f.valueOf(), _t.valueOf(), type, searchTerm).then(res => {
            setLoading(false);
            if (res && res.status) {
                let _data = {};

                for (let i = 0; i < res.data.length; i++) {
                    let item = res.data[i];
                    let d = new Date(item.startTime);
                    d.setHours(0, 0, 0, 0);
                    let k = d.valueOf();
                    _data[k] ? _data[k].push(item) : _data[k] = [item];
                }
                setData(_data)
            } else {
                setData(null);
            }
        }).catch(err => {
            console.log("err ===== ", err);
            setData(null);
            // setLoading(false);
            if(API.isCancel(err)) {
                console.log("API is canceled................");
            } else {
                setLoading(false);
            }
        })
    },[props.type, searchTerm] )

    let now = new Date();
    now.setHours(0, 0, 0, 0);
    console.log(slideData);
    return (
        <FileCtx.Provider value={{ selFile, setFileView }}>
            <div className="listContainer pos-rel"  ref={aptmntList}>
                <div className="searchBlock">
                    <div className="searchBox searchFull">
                        <form method="post" className="searchForm" onSubmit={(e)=>e.preventDefault()}>
                            <input className="textbox" title="Search" value={searchTerm} placeholder={l.search} type="text" 
                            // onChange={(e)=>{handleSerach(e)}}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </form>
                    </div>
                </div>

                {loading && <Loader/>}
                {data !== null && Object.keys(data) && Object.keys(data).length > 0 ?
                        Object.keys(data).sort((a, b) => a < b ? 1 : a > b ? -1 : 0).map(item => <div className="cardBlock" key={item}>
                            <div className="dateBlock">
                                <h2 className="dateCurrent">{Number(now.valueOf()) === Number(item) ? l.today : dateFormat(Number(item))}</h2>
                                {/* <div className="dateBox">
                        <span>FRI - Aug 16, 2020</span>
                    </div> */}
                            </div>
                            <div className="cardContainer">
                                {data[item].map(_item => 
                                <AppointmentItem updateWrCount={props.updateWrCount}
                                 data={_item} key={_item.appointmentId}
                                  loadData={loadData}
                                   type={props.type} 
                                   handleSlideData={handleSlideData}
                                   handleUploads={handleUploads}
                                   />)}
                            </div>
                        </div>)
                        : props.type === "PEA" && !loading ? <NoData Heading={l.no_appointments} src="/images/icons/pending-new.png" label='' />
                            : props.type === "UA" && !loading ? <NoData Heading={l.no_appointments} src="/images/icons/upcoming-new.png" label='' />
                                : !loading && <NoData Heading={l.no_appointments} src="/images/icons/cancelled-new.png" label='' />}
            </div>

                {slideData !== null && (
                    <VisitDetailsSlide
                        visitDetails={true}
                        handleClose={handleClose}
                        data={slideData}
                    />
                )}
                {/* slideUploadData */}
                {slideUploadData !== null && (
                    <PatientUploadsSlide 
                        open={true}
                     close={handleUploadsClose} 
                     data={slideUploadData.uploads} 
                     />
                )}
                
            {selFile !== null && <UploadFileView open={selFile !== null} handleClose={() => setFileView(null)} data={selFile} />}
        </FileCtx.Provider>
    )
}
export default DoctorAppointmentsList;